/* Styles - Statics */
import "../../styles/SearchOrders/searchOrders.scss";
import LoadingGif from "../../static/loader.gif";
/* Libs */
import React, { useEffect, useState } from "react";
/* Components */
import { CustomerOrders } from "./customerOrders/CustomerOrders";
/* Controllers - Helpers */
import { signIn } from "../../controllers/basicAuth";
import { getOrdersbyEmail } from "../../helpers/getOrders";


const pattern = new RegExp(
  /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
);
export const SearchOrders = () => {
  const initialValues = {
    errorInput: false,
    showOrders: false,
    loading: false,
    errorEmail: false,
  };
  const [initValues, setinitialValues] = useState(initialValues);
  const [data, setData] = useState({
    data: [],
  });
  const [token, settoken] = useState("");
  const [inputEmail, setinputEmail] = useState("");

  const handleInputChange = ({ target }) => {
    setinputEmail(target.value);
    if (!inputEmail || inputEmail === "") {
      setinitialValues({ ...initValues, errorInput: true });
    } else {
      setinitialValues({ ...initValues, errorInput: false });
    }
    if (!pattern.test(target.value)) {
      setinitialValues({ ...initValues, errorEmail: true, errorInput: false });
    } else {
      setinitialValues({ ...initValues, errorEmail: false, errorInput: false });
    }
  };

  const HandleSubmit = (e) => {
    e.preventDefault();
    if (!inputEmail || inputEmail === "") {
      setinitialValues({ ...initValues, errorInput: true });
      return;
    }

    getOrdersbyEmail(inputEmail, token).then((orders) => {
      setinitialValues({ ...initValues, loading: true, showOrders: false });
      setTimeout(function () {
        setData({
          data: orders,
        });
        setinitialValues({ ...initValues, showOrders: true, loading: false });
      }, 500);
    });
  };
  const printSOrder = () => {
    return (
      <CustomerOrders
        email={inputEmail}
        data={data}
        token={token}
        key={"CustomerOrders1"}
      />
    );
  };

  useEffect(() => {
    if (!token) {
      signIn()
        .then((value) => settoken(value))
        .catch((error) => console.log("error", error));
    }
  });
  return (
    <>
      <form onSubmit={HandleSubmit} className="font-family">
        <div className="container">
          <div className="element">
            <label
              className="label resizeLabels"
              htmlFor="emailOrders"
            >
              <span>
                <b>Email</b>
              </span>
            </label>
            <input
              type="text"
              id="emailOrders"
              name="emailOrders"
              value={inputEmail}
              onChange={handleInputChange}
              className="form-input field__input emailInput"
            ></input>
            {initValues.errorInput && (
              <span className="form-text error">
                Empty Email
              </span>
            )}
            {initValues.errorEmail && (
              <p className=" form-text error">
                Enter a Valid Email
              </p>
            )}
          </div>
          <br />
          <button
            type="submit"
            className="styled-submit button button-1"
            disabled={initValues.errorEmail ? true : false}
          >
            Search My Orders
          </button>
        </div>
      </form>
      <br />
      <br />
      {initValues.loading && (
        <p className="centered centered-items">
          Loading... <img src={LoadingGif} alt="Loading" />
        </p>
      )}
      <br />

      {initValues.showOrders && printSOrder()}
    </>
  );
};

export default SearchOrders;
